import { Button, Modal, Stack, Typography } from '@mui/material'
import XMarkSvg from '~/@ui/_sharedSvgs/FontAwesome/XMark.svg?react'
import { DataTable } from './DataTable'
import { Link } from 'react-router-dom'
import { IUser } from '~/@api/generated-api-types/global.types'
import { addressSplitter } from '~/@utils/adressSplitter/adressSplitter'

interface Props {
  user: IUser | null
  isDetailOpen: boolean
  closeDetail: () => void
}

export const DetailModal = ({ user, isDetailOpen, closeDetail }: Props) => {
  const personalInformation = user?._personalInformation || null
  const pensionOrder = user?._ownerPensionOrder || null
  const estate = user?._ownerPensionOrder?._estate || null

  const splittedAdress = addressSplitter(estate?.address || '')

  return (
    <Modal open={isDetailOpen} onClose={closeDetail} className="">
      <Stack className="w-full h-dvh items-center bg-zWhite100 overflow-auto">
        <Stack className="w-full max-w-[768px] px-6 pt-4 pb-28">
          <Stack className="flex-row justify-between">
            <Stack className="h-11 justify-center items-center px-4 bg-[#B3A0FF] rounded-full text-3d font-semibold text-zWhite200">
              Overovanie
            </Stack>
            <Button className="w-16 h-11 bg-zGrey200" onClick={closeDetail}>
              <XMarkSvg />
            </Button>
          </Stack>

          <Stack className="gap-3 mt-8">
            <Typography className="text-xl font-bold text-zBlack200">
              Žiadosť o druhý dôchodok
            </Typography>
            <Stack className="flex-row justify-between">
              <Typography className="text-xs font-medium text-zGrey400">
                {`ID: ${pensionOrder?.id}`}
              </Typography>
              <Typography className="text-xs font-medium text-zGrey400">
                {new Date(pensionOrder?.createdAt || '').toLocaleDateString(
                  'sk-SK'
                )}
              </Typography>
            </Stack>
          </Stack>

          <DataTable
            title="Druhý mesačný dôchodok"
            data={[
              {
                label: 'Druhý mesačný dôchodok',
                value: `${pensionOrder?.monthlyPensionValue} €`,
              },
              {
                label: 'Doba vypláciania',
                value:
                  (pensionOrder?.payoutYears ?? 0) +
                    (personalInformation?.age ?? 0) >=
                  95
                    ? 'doživotne'
                    : `${pensionOrder?.payoutYears} rokov`,
              },
            ]}
          />
          <DataTable
            title="Žiadateľ"
            data={[
              { label: 'Meno', value: personalInformation?.firstName || '' },
              {
                label: 'Priezvisko',
                value: personalInformation?.lastName || '',
              },
              { label: 'Vek', value: `${personalInformation?.age} Rokov` },
            ]}
          />
          <DataTable
            title="Údaje o nehnuteľnsti"
            data={[
              { label: 'Typ', value: estate?.type === 'flat' ? 'Byt' : 'Dom' },
              { label: 'Mesto', value: splittedAdress.city },
              { label: 'Adresa', value: splittedAdress.adress },
              //flat
              { label: 'Poschodie', value: estate?.level },
              { label: 'Číslo bytu', value: estate?.flatNumber },
              {
                label: 'Rozloha nehnuteľnosti v m²',
                value: estate?.flatArea || estate?.flatArea,
              },

              //house
              { label: 'Počet podlaží', value: estate?.numberOfFloors },
              { label: 'Úžitková plocha v m²', value: estate?.houseUsableArea },
              { label: 'Plocha pozemku v m²', value: estate?.landArea },

              { label: 'Stav nehnuteľnosti', value: estate?.status },
              { label: 'Počet izieb', value: estate?.numberOfRooms },
              { label: 'Počet wc', value: estate?.numberOfRestrooms },
              { label: 'Počet kúpeľní', value: estate?.numberOfBathrooms },
              {
                label: 'Počet parkovacích státí',
                value: estate?.numberOfParkingSpots,
              },
              {
                label: 'Počet garážových státí',
                value: estate?.numberOfGarageSpots,
              },
            ]}
          />

          <Link
            to="/vlastnik/help-center"
            className="
              text-3d font-medium text-zGrey400 underline underline-offset-2
              self-center mt-16
            ">
            Sú niektoré vaše údaje nesprávne?
          </Link>
        </Stack>
      </Stack>
    </Modal>
  )
}
